/**
 * AeroBackground — fixed-position iridescent backdrop. Mounted once at the
 * cockpit root so every glass surface above it can blur correctly.
 *
 * Six drifting bubbles + six twinkling sparkles, each with a hard-coded
 * position + animation-delay so the layout is deterministic between renders.
 * The body itself already paints the sunset gradient (see index.css `body`
 * rule); this component layers the floating particles on top.
 */
export default function AeroBackground() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 overflow-hidden"
      style={{ pointerEvents: "none" }}
    >
      {/* Bubbles */}
      <div className="aero-bubble" style={{ width: 140, height: 140, top: "8%", left: "6%", animationDelay: "-3s" }} />
      <div className="aero-bubble" style={{ width: 90, height: 90, top: "18%", right: "12%", animationDelay: "-9s" }} />
      <div className="aero-bubble" style={{ width: 200, height: 200, top: "55%", left: "-3%", animationDelay: "-12s" }} />
      <div className="aero-bubble" style={{ width: 120, height: 120, top: "42%", right: "5%", animationDelay: "-6s" }} />
      <div className="aero-bubble" style={{ width: 80, height: 80, top: "78%", right: "22%", animationDelay: "-15s" }} />
      <div className="aero-bubble" style={{ width: 60, height: 60, top: "88%", left: "38%", animationDelay: "-2s" }} />

      {/* Sparkles */}
      <div className="aero-sparkle" style={{ top: "14%", left: "30%", animationDelay: "0s" }} />
      <div className="aero-sparkle" style={{ top: "25%", right: "40%", animationDelay: "0.7s" }} />
      <div className="aero-sparkle" style={{ top: "62%", left: "15%", animationDelay: "1.4s" }} />
      <div className="aero-sparkle" style={{ top: "75%", right: "28%", animationDelay: "2.1s" }} />
      <div className="aero-sparkle" style={{ top: "35%", left: "55%", animationDelay: "1s" }} />
      <div className="aero-sparkle" style={{ top: "8%", right: "8%", animationDelay: "2.5s" }} />
    </div>
  );
}
